<script setup>
import { ref, onMounted, computed, watch, nextTick, onUnmounted } from "vue";
import axios from "axios";
import SlideShow from "./SlideShow.vue";
import Accordion from "./Accordion.vue";
import ModalContact from "./ModalContact.vue";
import SliderGamas from "./sliderGamas.vue";
import sliderGamasUrbano from "./sliderGamasUrbano.vue";

import "swiper/css";
import "swiper/css/pagination";
import GalleryImage from "./galleryImage.vue";

const emits = defineEmits(["product-navigated"]);
const isFixed = ref(false);
const contentNewRef = ref(null);
const showModal = ref(false);
const isOpen = ref(false);
const trans = (key) => {
  return _.get(window.translations, key, key);
};

const currentUrl = ref("");
const currentTitle = ref("");

const props = defineProps({
  breadcrumb: Array,
  model: Object,
  submitUrl: String,
});

const ReferenceModel = ref(props.model);
const model = ref(JSON.parse(JSON.stringify(props.model)));
const activeArea = ref(0);

const toggleShare = () => {
  isOpen.value = !isOpen.value;
};

const updateUrl = (variantId = null) => {
  const pageUrl = new URL(window.location);
  pageUrl.searchParams.delete("variant_id");

  if (variantId !== null && variantId !== ReferenceModel.value.id) {
    pageUrl.searchParams.set("variant_id", variantId);
  }
  window.history.replaceState(null, "", pageUrl.toString());
};
const dynamicBreadcrumb = computed(() => {
  if (!props.breadcrumb || props.breadcrumb.length === 0) return [];
  const bread = [...props.breadcrumb];
  if (bread.length > 0) {
    bread[bread.length - 1] = {
      ...bread[bread.length - 1],
      label: model.value.name,
    };
  }
  return bread;
});
const selectedOptions = ref({
  color: [ReferenceModel.value.colors[0], ReferenceModel.value.colors[0]],
});

const productKey = computed(
  () => `${model.value.id}-${model.value.reference}`,
);

const toggleColor = async (color, indexArea) => {
  selectedOptions.value.color[indexArea] = color;
  const newVariant = ReferenceModel.value.variationProducts.find(
    (variant) => {
      return variant.colors[indexArea]?.id === color.id;
    },
  );

  if (newVariant) {
    model.value = newVariant;
    updateUrl(newVariant.id);
  } else {
    const apiVariant = await fetchVariantByConfiguration();
    if (apiVariant) {
      model.value = apiVariant;
    }
  }
};

const fetchVariantByConfiguration = async () => {
  const apiParams = {
    c1: selectedOptions.value.color[0].value,
    c2:
      selectedOptions.value.color[1]?.value ||
      selectedOptions.value.color[0].value,
  };
  const urlToFetch = `/api/topcer/${ReferenceModel.value.id}/getVariantsByColorProductsId`;
  try {
    const { data } = await axios.get(urlToFetch, { params: apiParams });
    updateUrl(data.id);
    return data;
  } catch (error) {
    console.error("Erro ao buscar variante por configuração:", error);
    return null;
  }
};

const loadMounted = async (isFirstLoad = false) => {
  await nextTick();

  if (isFirstLoad) {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant_id");
    if (variantId) {
      const variant = ReferenceModel.value.variationProducts?.find(
        (vp) => vp.id === parseInt(variantId),
      );
      if (variant) model.value = variant;
    } else if (ReferenceModel.value.variationProducts?.length > 0) {
      model.value = ReferenceModel.value.variationProducts[0];
      updateUrl(model.value.id);
    }
  }

  if (model.value && model.value.colors) {
    selectedOptions.value.color[0] = model.value.colors[0];
    selectedOptions.value.color[1] =
      model.value.colors[1] || model.value.colors[0];
  }

  if (ReferenceModel.value.featured_image?.svg) {
    getGroups(ReferenceModel.value.featured_image.svg, isFirstLoad);
  }
};

const handleScroll = () => {
  if (contentNewRef.value) {
    const rect = contentNewRef.value.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    isFixed.value = rect.bottom > windowHeight;
  }
};

onMounted(async () => {
  await loadMounted(true);
  window.addEventListener("scroll", handleScroll);
  handleScroll();
  currentUrl.value = window.location.href;
  currentTitle.value = document.title;
});
const shareSocial = (type) => {
  const url = encodeURIComponent(currentUrl.value);
  const title = encodeURIComponent(currentTitle.value);

  const shareLinks = {
    fb: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    instagram: `https://www.instagram.com/`,
    whatsapp: `https://api.whatsapp.com/send?text=${title}%20${url}`,
  };

  const link = shareLinks[type];

  if (link) {
    window.open(link, "_blank", "noopener,noreferrer");
  }
};

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<template>
  <div class="container-page-product">
    <div
      class="container-rural"
      v-if="ReferenceModel.majorCategory === 'Mobilidade Rural'">
      <div class="banner-image">
        <img
          v-if="
            ReferenceModel.dynamicGalleries &&
            ReferenceModel.dynamicGalleries.length > 0
          "
          :src="ReferenceModel.dynamicGalleries[0].fullUrl"
          :alt="ReferenceModel.dynamicGalleries[0].title" />
      </div>
      <div class="container-produto">
        <div class="content" ref="contentNewRef">
          <div class="pre">
            <div class="pre-content">
              <div class="container-text" :key="productKey">
                <h1>
                  {{ ReferenceModel.name }}
                  <span>{{ ReferenceModel.reference }}</span>
                </h1>
                <p>{{ ReferenceModel.label_list }}</p>
              </div>
            </div>
            <div class="container-colors">
              <div
                class="content-colours"
                v-if="
                  ReferenceModel.colors && ReferenceModel.colors.length > 0
                ">
                <div class="content-cards">
                  <div class="colours">
                    <div class="content-colors">
                      <div
                        v-for="color in ReferenceModel.colors"
                        :key="color.id">
                        <div
                          class="card"
                          @click="toggleColor(color, activeArea)"
                          :class="{
                            'active-color':
                              selectedOptions.color[activeArea]?.id ===
                              color.id,
                          }">
                          <p>{{ color.name }}</p>
                          <div
                            class="card-image"
                            :class="{
                              'selected-color-image':
                                selectedOptions.color[activeArea]?.id ===
                                color.id,
                            }">
                            <img
                              :src="color.featured_image_300x300"
                              :alt="color.name" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container-geral">
            <div class="container-info">
              <div
                class="content-description"
                v-if="
                  model?.content?.length > 0 ||
                  ReferenceModel?.content?.length > 0
                ">
                <div class="text">
                  <div
                    class="lead"
                    v-if="model?.lead?.length > 0"
                    v-html="model.lead"></div>
                  <div class="lead" v-else v-html="ReferenceModel.lead"></div>
                  <div
                    class="description"
                    v-if="model?.content?.length > 0"
                    v-html="model.content"></div>
                  <div
                    class="description"
                    v-else
                    v-html="ReferenceModel.content"></div>
                </div>
                <div class="peso" v-if="ReferenceModel.weight !== null">
                  <div class="svg-peso">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="46"
                      viewBox="0 0 32 46"
                      fill="none">
                      <path
                        d="M15.9892 13.6361C18.4124 13.6361 20.7059 14.1824 22.7397 15.1439C23.4753 13.9202 23.9513
                      12.4779 23.9513 10.9264C23.9513 8.74109 23.0859 6.70879 21.593 5.26651C20.1866 3.82423 18.2177
                      2.88456 15.9892 2.88456C13.7606 2.88456 11.8134 3.84608 10.3854 5.26651C8.8925 6.68694 8.02705
                      8.74109 8.02705 10.9264C8.02705 12.4998 8.50304 13.9202 9.23868 15.1439C11.2508 14.1824 13.5659
                      13.6361 15.9892 13.6361ZM16.119 33.7406L13.1548 28.8238L15.9892 25.8955H12.8087L10.3205
                      28.8238V25.8955H7.89723V33.7406H10.3205V31.8394L11.5321 30.5501L13.1548
                      33.7625H16.119V33.7406ZM22.2637 26.0266C21.8526 25.8299 21.2468 25.7644 20.3813 25.7644C19.5159
                      25.7644 18.8235 25.8955 18.2826 26.1796C17.6119 26.5292 17.071 27.01 16.7248 27.6C16.3786
                      28.2119 16.1839 28.9549 16.1839 29.7853C16.1839 30.6157 16.3786 31.3587 16.7248 31.9705C16.9844
                      32.5824 17.4604 33.0632 18.0014 33.391C18.6072 33.6532 19.3428 33.8717 20.2948 33.8717C21.0304
                      33.8717 21.6362 33.7406 22.1771 33.6095C22.7181 33.4128 23.3239 33.0632 24.0595
                      32.5824V29.239H20.3381V30.8779H21.9608V31.6209C21.6146 31.8176 21.355 31.9705
                      21.1602 32.0361C20.9006 32.1017 20.6193 32.1017 20.3381 32.1017C19.7972 32.1017 19.3861
                      31.9705 19.0615 31.6209C18.7153 31.2057 18.5855 30.5938 18.5855 29.7853C18.5855 28.9767
                      18.7153 28.4304 19.0615 28.0152C19.3212 27.6656 19.7972 27.4689 20.2732 27.4689C20.6842
                      27.4689 20.9439 27.6 21.1602 27.7311C21.4199 27.8622 21.5713 28.0808 21.6362 28.4086L23.9297
                      27.9934C23.7999 27.447 23.6051 27.0318 23.3239 26.704C23.0642 26.4418 22.7181 26.1577 22.2421
                      26.0266M15.9892 0C18.9533 0 21.7228 1.22375 23.6917 3.21235C25.6389 5.1791 26.8722 7.91069
                      26.8722 10.9045C26.8722 13.0242 26.2664 14.9254 25.2495 16.6299C29.3604 19.5582 32 24.3221
                      32 29.7853C32 38.723 24.8384 46 16.0108 46C7.18323 46 0 38.7012 0 29.7853C0 24.3439 2.63962
                      19.5582 6.75051 16.6299C5.7336 14.9254 5.1927 13.0242 5.1927 10.9045C5.1927 7.91069 6.40433
                      5.1791 8.37323 3.21235C10.3205 1.24561 13.025 0 15.9892 0Z"
                        fill="black" />
                    </svg>
                  </div>
                  <div class="capacidade">
                    <p>
                      Capacidade de carga: até {{ ReferenceModel.weight }} kg
                    </p>
                  </div>
                </div>
                <div class="container-button">
                  <div class="buttons">
                    <button
                      class="button-orange interested"
                      @click="showModal = true">
                      Estou interessado
                    </button>
                    <button class="button-orange buy-content">
                      <a id="link" href="/pt/contactos-2" target="_blank"
                      >Onde comprar</a
                      >
                    </button>
                  </div>
                  <button class="share" @click="toggleShare">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none">
                      <path
                        d="M22.0002 4.99993C22 3.82696 22.4124 2.69128 23.1651 1.7916C23.9178 0.891916 24.9629
                        0.285515 26.1176 0.0784913C27.2723 -0.128532 28.4631 0.077004 29.4815 0.65914C30.5 1.24128
                        31.2813 2.16294 31.6887 3.26289C32.0962 4.36283 32.1039 5.57101 31.7104 6.67604C31.3169
                        7.78107 30.5474 8.71258 29.5364 9.30761C28.5255 9.90263 27.3374 10.1233 26.1802
                        9.93094C25.023 9.7386 23.9702 9.14552 23.2061 8.25547L9.77037 14.4946C10.0791 15.4734
                        10.0791 16.5234 9.77037 17.5022L23.2061 23.7413C24.0138 22.8021 25.1414 22.1961 26.3705
                        22.0408C27.5995 21.8856 28.8425 22.192 29.8584 22.9008C30.8743 23.6096 31.5909 24.6703
                        31.8693 25.8772C32.1477 27.0842 31.9681 28.3516 31.3652 29.4337C30.7623 30.5157 29.7791
                        31.3355 28.6062 31.7341C27.4333 32.1327 26.1541 32.0817 25.0167 31.591C23.8792 31.1003
                        22.9644 30.2049 22.4496 29.0783C21.9348 27.9517 21.8566 26.674 22.2302 25.4931L8.79438
                        19.2539C8.12926 20.029 7.24271 20.5817 6.25398 20.8379C5.26526 21.094 4.22179 21.0413
                        3.26395 20.6867C2.30611 20.3321 1.47986 19.6927 0.89633 18.8546C0.312803 18.0164 0 17.0196
                        0 15.9984C0 14.9771 0.312803 13.9804 0.89633 13.1422C1.47986 12.304 2.30611 11.6647 3.26395
                        11.3101C4.22179 10.9555 5.26526 10.9027 6.25398 11.1589C7.24271 11.415 8.12926 11.9678
                        8.79438 12.7428L22.2302 6.50372C22.0772 6.01712 21.9997 5.50999 22.0002 4.99993Z"
                        fill="#ACACAC" />
                    </svg>
                  </button>
                </div>
                <div class="list-redes" :class="{ open: isOpen }">
                  <ul>
                    <li>
                      <button
                        @click="shareSocial('fb')"
                        class="btn btn-default social_share"
                        title="Facebook">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none">
                          <g clip-path="url(#clip0_28_647)">
                            <path
                              d="M30 15.0919C30 6.75562 23.2837 -0.00187683 15 -0.00187683C6.71246 -1.83098e-06
                             -0.00378418 6.75562 -0.00378418 15.0937C-0.00378418 22.6256 5.48247 28.8694 12.6525
                             30.0019V19.455H8.84622V15.0937H12.6562V11.7656C12.6562 7.98375 14.8968 5.895 18.3225
                             5.895C19.965 5.895 21.6806 6.18937 21.6806 6.18937V9.90187H19.7887C17.9268 9.90187
                             17.3456 11.0662 17.3456 12.2606V15.0919H21.5043L20.8406 19.4531H17.3437V30C24.5137
                             28.8675 30 22.6237 30 15.0919Z"
                              fill="#ACACAC" />
                          </g>
                          <defs>
                            <clipPath id="clip0_28_647">
                              <rect width="30" height="30" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                    </li>
                    <li>
                      <button
                        @click="shareSocial('instagram')"
                        class="btn btn-default social_share"
                        title="Instagram">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none">
                          <g clip-path="url(#clip0_28_649)">
                            <path
                              d="M15 0C10.9294 0 10.4175 0.01875 8.81812 0.09C7.21875 0.165 6.12937 0.41625 5.175
                            0.7875C4.17346 1.16311 3.26651 1.75387 2.51813 2.51813C1.75387 3.26651 1.16311 4.17346
                            0.7875 5.175C0.41625 6.1275 0.163125 7.21875 0.09 8.8125C0.01875 10.4156 0 10.9256 0
                            15.0019C0 19.0744 0.01875 19.5844 0.09 21.1838C0.165 22.7812 0.41625 23.8706 0.7875
                            24.825C1.17188 25.8112 1.68375 26.6475 2.51813 27.4819C3.35063 28.3162 4.18687 28.83
                            5.17313 29.2125C6.12937 29.5837 7.21688 29.8369 8.81437 29.91C10.4156 29.9812 10.9256
                            30 15 30C19.0744 30 19.5825 29.9812 21.1838 29.91C22.7794 29.835 23.8725 29.5837 24.8269
                            29.2125C25.8277 28.8366 26.734 28.2459 27.4819 27.4819C28.3162 26.6475 28.8281 25.8112
                            29.2125 24.825C29.5819 23.8706 29.835 22.7812 29.91 21.1838C29.9812 19.5844 30 19.0744
                            30 15C30 10.9256 29.9812 10.4156 29.91 8.81437C29.835 7.21875 29.5819 6.1275 29.2125
                            5.175C28.8369 4.17346 28.2461 3.26651 27.4819 2.51813C26.7335 1.75387 25.8265 1.16311
                            24.825 0.7875C23.8687 0.41625 22.7775 0.163125 21.1819 0.09C19.5806 0.01875 19.0725 0
                            14.9963 0H15ZM13.6556 2.70375H15.0019C19.0069 2.70375 19.4812 2.71688 21.0619 2.79C22.5244
                            2.85563 23.3194 3.10125 23.8481 3.30562C24.5475 3.5775 25.0481 3.90375 25.5731
                            4.42875C26.0981 4.95375 26.4225 5.4525 26.6944 6.15375C26.9006 6.68062 27.1444 7.47563
                            27.21 8.93813C27.2831 10.5188 27.2981 10.9931 27.2981 14.9963C27.2981 18.9994 27.2831
                            19.4756 27.21 21.0562C27.1444 22.5187 26.8988 23.3119 26.6944 23.8406C26.4522 24.4911
                            26.0686 25.0796 25.5712 25.5637C25.0462 26.0887 24.5475 26.4131 23.8463 26.685C23.3213
                            26.8913 22.5262 27.135 21.0619 27.2025C19.4812 27.2738 19.0069 27.2906 15.0019
                            27.2906C10.9969 27.2906 10.5206 27.2738 8.94 27.2025C7.4775 27.135 6.68437 26.8913
                            6.15562 26.685C5.50469 26.4436 4.9155 26.0606 4.43062 25.5637C3.93239 25.0793 3.54812
                            24.49 3.30562 23.8387C3.10125 23.3119 2.85563 22.5169 2.79 21.0544C2.71875 19.4738
                            2.70375 18.9994 2.70375 14.9925C2.70375 10.9856 2.71875 10.515 2.79 8.93437C2.8575
                            7.47187 3.10125 6.67688 3.3075 6.14813C3.57938 5.44875 3.90562 4.94812 4.43062
                            4.42312C4.95563 3.89812 5.45437 3.57375 6.15562 3.30188C6.68437 3.09563 7.4775 2.85188
                            8.94 2.78437C10.3238 2.72062 10.86 2.70188 13.6556 2.7V2.70375ZM23.0081 5.19375C22.7717
                            5.19375 22.5377 5.24031 22.3193 5.33077C22.1009 5.42123 21.9025 5.55381 21.7353
                            5.72096C21.5682 5.8881 21.4356 6.08653 21.3451 6.30492C21.2547 6.52331 21.2081 6.75737
                            21.2081 6.99375C21.2081 7.23013 21.2547 7.46419 21.3451 7.68258C21.4356 7.90097 21.5682
                            8.0994 21.7353 8.26654C21.9025 8.43369 22.1009 8.56627 22.3193 8.65673C22.5377 8.74719
                            22.7717 8.79375 23.0081 8.79375C23.4855 8.79375 23.9434 8.60411 24.2809 8.26654C24.6185
                            7.92898 24.8081 7.47114 24.8081 6.99375C24.8081 6.51636 24.6185 6.05852 24.2809
                            5.72096C23.9434 5.38339 23.4855 5.19375 23.0081 5.19375ZM15.0019 7.2975C13.9801 7.28156
                            12.9654 7.46904 12.0168 7.84901C11.0682 8.22899 10.2047 8.79388 9.47653 9.51079C8.74835
                            10.2277 8.17006 11.0823 7.77533 12.0249C7.3806 12.9674 7.17731 13.9791 7.17731
                            15.0009C7.17731 16.0228 7.3806 17.0345 7.77533 17.977C8.17006 18.9196 8.74835 19.7742
                            9.47653 20.4911C10.2047 21.208 11.0682 21.7729 12.0168 22.1529C12.9654 22.5328 13.9801
                            22.7203 15.0019 22.7044C17.0241 22.6728 18.9529 21.8473 20.3718 20.4061C21.7908 18.9649
                            22.5861 17.0234 22.5861 15.0009C22.5861 12.9784 21.7908 11.037 20.3718 9.59578C18.9529
                            8.15454 17.0241 7.32905 15.0019 7.2975ZM15.0019 9.99938C15.6586 9.99938 16.3088 10.1287
                            16.9155 10.38C17.5222 10.6313 18.0735 10.9997 18.5379 11.464C19.0022 11.9284 19.3705
                            12.4796 19.6219 13.0863C19.8732 13.693 20.0025 14.3433 20.0025 15C20.0025 15.6567 19.8732
                            16.307 19.6219 16.9137C19.3705 17.5204 19.0022 18.0716 18.5379 18.536C18.0735 19.0003
                            17.5222 19.3687 16.9155 19.62C16.3088 19.8713 15.6586 20.0006 15.0019 20.0006C13.6756
                            20.0006 12.4037 19.4738 11.4659 18.536C10.5281 17.5982 10.0013 16.3262 10.0013 15C10.0013
                            13.6738 10.5281 12.4018 11.4659 11.464C12.4037 10.5262 13.6756 9.99938 15.0019 9.99938Z"
                              fill="#ACACAC" />
                          </g>
                          <defs>
                            <clipPath id="clip0_28_649">
                              <rect width="30" height="30" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                    </li>
                    <li>
                      <button
                        @click="shareSocial('whatsapp')"
                        class="btn btn-default social_share"
                        title="WhatsApp">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none">
                          <g clip-path="url(#clip0_28_651)">
                            <path
                              d="M25.5019 4.36135C24.1268 2.97291 22.4889 1.87219 20.6839 1.1234C18.8789 0.37462
                            16.9429 -0.00723904 14.9887 0.000103922C6.80062 0.000103922 0.1275 6.67135 0.12
                            14.8614C0.12 17.4845 0.80625 20.0364 2.10188 22.2957L0 30.0001L7.8825 27.9339C10.0622
                            29.123 12.5058 29.7452 14.9887 29.7432H14.9963C23.1863 29.7432 29.8575 23.072 29.865
                            14.8745C29.8667 12.9208 29.4819 10.9862 28.7327 9.18187C27.9836 7.37757 26.8868 5.73929
                            25.5019 4.36135ZM14.9887 27.227C12.7747 27.2252 10.6017 26.6295 8.69625 25.502L8.24625
                            25.232L3.57 26.4582L4.81875 21.8964L4.52625 21.4257C3.28839 19.4576 2.63371 17.1789
                            2.63812 14.8539C2.63812 8.0551 8.1825 2.50885 14.9963 2.50885C16.6195 2.50594 18.2273
                            2.82437 19.7269 3.44578C21.2265 4.06718 22.5883 4.97928 23.7337 6.12948C24.8829 7.27538
                            25.794 8.63737 26.4144 10.137C27.0349 11.6366 27.3524 13.2441 27.3488 14.867C27.3413
                            21.6901 21.7969 27.227 14.9887 27.227ZM21.7669 17.9757C21.3975 17.7901 19.5731 16.892
                            19.23 16.7645C18.8888 16.6426 18.6394 16.5789 18.3956 16.9501C18.1462 17.3195 17.4338
                            18.1614 17.22 18.4032C17.0063 18.6526 16.785 18.6807 16.4137 18.497C16.0444 18.3095
                            14.8463 17.9195 13.4288 16.6501C12.3225 15.6657 11.5819 14.447 11.3606 14.0776C11.1469
                            13.7064 11.34 13.5076 11.5256 13.322C11.6887 13.157 11.895 12.887 12.0806 12.6732C12.2681
                            12.4595 12.33 12.302 12.4519 12.0545C12.5737 11.8032 12.5156 11.5895 12.4237
                            11.4039C12.33 11.2182 11.5894 9.38635 11.2762 8.6476C10.9762 7.91823 10.6706 8.01948
                            10.4419 8.0101C10.2281 7.99698 9.97875 7.99698 9.72937 7.99698C9.54108 8.00177 9.35579
                            8.04538 9.18512 8.12507C9.01445 8.20476 8.86207 8.31882 8.7375 8.4601C8.39625 8.83135
                            7.44187 9.72948 7.44187 11.5614C7.44187 13.3932 8.77312 15.1539 8.96062 15.4032C9.14437
                            15.6526 11.5744 19.4007 15.3037 21.0132C16.185 21.3976 16.8787 21.6245 17.4206
                            21.797C18.3113 22.082 19.1156 22.0389 19.7569 21.947C20.4694 21.8382 21.9525 21.047
                            22.2656 20.1789C22.5731 19.3089 22.5731 18.5664 22.4794 18.4107C22.3875 18.2532 22.1381
                            18.1614 21.7669 17.9757Z"
                              fill="#ACACAC" />
                          </g>
                          <defs>
                            <clipPath id="clip0_28_651">
                              <rect width="30" height="30" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="container-images">
              <div class="container-colors-bottom">
                <div
                  class="content-colours"
                  v-if="
                    ReferenceModel.colors && ReferenceModel.colors.length > 0
                  ">
                  <div class="content-cards">
                    <div class="colours">
                      <div class="content-colors">
                        <div
                          v-for="color in ReferenceModel.colors"
                          :key="color.id">
                          <div
                            class="card"
                            @click="toggleColor(color, activeArea)"
                            :class="{
                              'active-color':
                                selectedOptions.color[activeArea]?.id ===
                                color.id,
                            }">
                            <p>{{ color.name }}</p>
                            <div
                              class="card-image"
                              :class="{
                                'selected-color-image':
                                  selectedOptions.color[activeArea]?.id ===
                                  color.id,
                              }">
                              <img
                                :src="color.featured_image_300x300"
                                :alt="color.name" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="gallery-wrapper">
                <img :src="model.featured_image.fullUrl" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="container-accordion">
          <h2>Especificações</h2>
          <Accordion
            v-if="ReferenceModel.dynamicTables"
            :tables="ReferenceModel.dynamicTables"
            :documents="ReferenceModel.documents"
            :model="model" />
        </div>

        <div class="container-info-product">
          <div class="container-gallery-image">
            <gallery-image :gallery="model.dynamicGalleries" />
          </div>
          <div class="container-banner">
            <div class="banner">
              <img
                v-if="
                  model.dynamicGalleries &&
                  ReferenceModel.dynamicGalleries.length > 0
                "
                :src="model.dynamicGalleries[1].fullUrl"
                :alt="model.dynamicGalleries[1].title" />
            </div>
          </div>
          <div class="header">
            <p>Detalhes que fazem a diferença</p>
          </div>
          <div class="content-images">
            <slide-show :icons="ReferenceModel.iconography" />
          </div>

          <div class="container-other-gamas">
            <h2>Outras gamas disponíveis</h2>
            <div class="container-related-product" style="width: 100%">
              <slider-gamas
                :related="ReferenceModel.relatedProduct"
                :model="model" />
            </div>
          </div>
        </div>
      </div>

      <ModalContact
        :model="model"
        v-model="showModal"
        :productName="ReferenceModel"
        :productVariant="model" />
    </div>
    <div
      class="container-urbano"
      v-if="ReferenceModel.majorCategory === 'Mobilidade Urbana'">
      <div
        class="banner-image"
        :class="{
          'navy-color': model.reference === 'Navy',
          'mint-color': model.reference === 'Mint',
          'pink-color': model.reference === 'Pink',
          'snow-color': model.reference === 'Snow',
        }">
        <img
          v-if="model.dynamicGalleries && model.dynamicGalleries.length > 0"
          :src="model.dynamicGalleries[1].fullUrl"
          :alt="model.dynamicGalleries[1].title" />
      </div>
      <div class="container-produto">
        <div class="content" ref="contentNewRef">
          <div class="container-geral">
            <div class="container-info">
              <div class="pre-content">
                <div class="container-text" :key="productKey">
                  <div class="txt-izi">
                    <div class="image-izi">
                      <img :src="model.dynamicGalleries?.[0]?.fullUrl" alt="" />
                    </div>
                    <h1
                      :class="{
                        'navy-color': model.reference === 'Navy',
                        'mint-color': model.reference === 'Mint',
                        'pink-color': model.reference === 'Pink',
                        'snow-color': model.reference === 'Snow',
                      }">
                      {{ model.reference }}
                    </h1>
                  </div>
                  <p>{{ model.label_list }}</p>
                </div>
              </div>
              <div
                class="content-description"
                v-if="
                  model.content.length > 0 || ReferenceModel.content.length > 0
                ">
                <div
                  class="lead"
                  :class="{
                    'navy-color': model.reference === 'Navy',
                    'mint-color': model.reference === 'Mint',
                    'pink-color': model.reference === 'Pink',
                    'snow-color': model.reference === 'Snow',
                  }"
                  v-if="model.lead.length > 0"
                  v-html="model.lead"></div>
                <div class="lead" v-else v-html="ReferenceModel.lead"></div>
                <div
                  class="description"
                  :class="{
                    'navy-color': model.reference === 'Navy',
                    'mint-color': model.reference === 'Mint',
                    'pink-color': model.reference === 'Pink',
                    'snow-color': model.reference === 'Snow',
                  }"
                  v-if="model.content.length > 0"
                  v-html="model.content"></div>
                <div
                  class="description"
                  :class="{
                    'navy-color': model.reference === 'Navy',
                    'mint-color': model.reference === 'Mint',
                    'pink-color': model.reference === 'Pink',
                    'snow-color': model.reference === 'Snow',
                  }"
                  v-else
                  v-html="ReferenceModel.content"></div>

                <div class="container-button">
                  <div class="buttons">
                    <button
                      class="interested"
                      :class="{
                        'navy-color': model.reference === 'Navy',
                        'mint-color': model.reference === 'Mint',
                        'pink-color': model.reference === 'Pink',
                        'snow-color': model.reference === 'Snow',
                      }"
                      @click="showModal = true">
                      Estou interessado
                    </button>
                    <button
                      class="buy"
                      :class="{
                        'navy-color': model.reference === 'Navy',
                        'mint-color': model.reference === 'Mint',
                        'pink-color': model.reference === 'Pink',
                        'snow-color': model.reference === 'Snow',
                      }">
                      <a href="/pt/contactos-2" target="_blank">Onde comprar</a>
                    </button>
                  </div>
                  <button class="share" @click="toggleShare">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none">
                      <path
                        d="M22.0002 4.99993C22 3.82696 22.4124 2.69128 23.1651 1.7916C23.9178 0.891916 24.9629
                        0.285515 26.1176 0.0784913C27.2723 -0.128532 28.4631 0.077004 29.4815 0.65914C30.5 1.24128
                        31.2813 2.16294 31.6887 3.26289C32.0962 4.36283 32.1039 5.57101 31.7104 6.67604C31.3169
                        7.78107 30.5474 8.71258 29.5364 9.30761C28.5255 9.90263 27.3374 10.1233 26.1802 9.93094C25.023
                        9.7386 23.9702 9.14552 23.2061 8.25547L9.77037 14.4946C10.0791 15.4734 10.0791 16.5234 9.77037
                        17.5022L23.2061 23.7413C24.0138 22.8021 25.1414 22.1961 26.3705 22.0408C27.5995 21.8856
                        28.8425 22.192 29.8584 22.9008C30.8743 23.6096 31.5909 24.6703 31.8693 25.8772C32.1477
                        27.0842 31.9681 28.3516 31.3652 29.4337C30.7623 30.5157 29.7791 31.3355 28.6062
                        31.7341C27.4333 32.1327 26.1541 32.0817 25.0167 31.591C23.8792 31.1003 22.9644 30.2049
                        22.4496 29.0783C21.9348 27.9517 21.8566 26.674 22.2302 25.4931L8.79438 19.2539C8.12926
                        20.029 7.24271 20.5817 6.25398 20.8379C5.26526 21.094 4.22179 21.0413 3.26395 20.6867C2.30611
                        20.3321 1.47986 19.6927 0.89633 18.8546C0.312803 18.0164 0 17.0196 0 15.9984C0 14.9771
                        0.312803 13.9804 0.89633 13.1422C1.47986 12.304 2.30611 11.6647 3.26395 11.3101C4.22179
                        10.9555 5.26526 10.9027 6.25398 11.1589C7.24271 11.415 8.12926 11.9678 8.79438 12.7428L22.2302
                        6.50372C22.0772 6.01712 21.9997 5.50999 22.0002 4.99993Z"
                        fill="#ACACAC" />
                    </svg>
                  </button>
                </div>
                <div class="list-redes" :class="{ open: isOpen }">
                  <ul>
                    <li>
                      <button
                        @click="shareSocial('fb')"
                        class="btn btn-default social_share"
                        title="Facebook">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none">
                          <g clip-path="url(#clip0_28_647)">
                            <path
                              d="M30 15.0919C30 6.75562 23.2837 -0.00187683 15 -0.00187683C6.71246 -1.83098e-06
                             -0.00378418 6.75562 -0.00378418 15.0937C-0.00378418 22.6256 5.48247 28.8694 12.6525
                             30.0019V19.455H8.84622V15.0937H12.6562V11.7656C12.6562 7.98375 14.8968 5.895 18.3225
                             5.895C19.965 5.895 21.6806 6.18937 21.6806 6.18937V9.90187H19.7887C17.9268 9.90187
                             17.3456 11.0662 17.3456 12.2606V15.0919H21.5043L20.8406 19.4531H17.3437V30C24.5137
                             28.8675 30 22.6237 30 15.0919Z"
                              fill="#ACACAC" />
                          </g>
                          <defs>
                            <clipPath id="clip0_28_647">
                              <rect width="30" height="30" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                    </li>
                    <li>
                      <button
                        @click="shareSocial('instagram')"
                        class="btn btn-default social_share"
                        title="Instagram">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none">
                          <g clip-path="url(#clip0_28_649)">
                            <path
                              d="M15 0C10.9294 0 10.4175 0.01875 8.81812 0.09C7.21875 0.165 6.12937 0.41625 5.175
                            0.7875C4.17346 1.16311 3.26651 1.75387 2.51813 2.51813C1.75387 3.26651 1.16311 4.17346
                            0.7875 5.175C0.41625 6.1275 0.163125 7.21875 0.09 8.8125C0.01875 10.4156 0 10.9256 0
                            15.0019C0 19.0744 0.01875 19.5844 0.09 21.1838C0.165 22.7812 0.41625 23.8706 0.7875
                            24.825C1.17188 25.8112 1.68375 26.6475 2.51813 27.4819C3.35063 28.3162 4.18687 28.83
                            5.17313 29.2125C6.12937 29.5837 7.21688 29.8369 8.81437 29.91C10.4156 29.9812 10.9256
                            30 15 30C19.0744 30 19.5825 29.9812 21.1838 29.91C22.7794 29.835 23.8725 29.5837 24.8269
                            29.2125C25.8277 28.8366 26.734 28.2459 27.4819 27.4819C28.3162 26.6475 28.8281 25.8112
                            29.2125 24.825C29.5819 23.8706 29.835 22.7812 29.91 21.1838C29.9812 19.5844 30 19.0744
                            30 15C30 10.9256 29.9812 10.4156 29.91 8.81437C29.835 7.21875 29.5819 6.1275 29.2125
                            5.175C28.8369 4.17346 28.2461 3.26651 27.4819 2.51813C26.7335 1.75387 25.8265 1.16311
                            24.825 0.7875C23.8687 0.41625 22.7775 0.163125 21.1819 0.09C19.5806 0.01875 19.0725 0
                            14.9963 0H15ZM13.6556 2.70375H15.0019C19.0069 2.70375 19.4812 2.71688 21.0619 2.79C22.5244
                            2.85563 23.3194 3.10125 23.8481 3.30562C24.5475 3.5775 25.0481 3.90375 25.5731
                            4.42875C26.0981 4.95375 26.4225 5.4525 26.6944 6.15375C26.9006 6.68062 27.1444 7.47563
                            27.21 8.93813C27.2831 10.5188 27.2981 10.9931 27.2981 14.9963C27.2981 18.9994 27.2831
                            19.4756 27.21 21.0562C27.1444 22.5187 26.8988 23.3119 26.6944 23.8406C26.4522 24.4911
                            26.0686 25.0796 25.5712 25.5637C25.0462 26.0887 24.5475 26.4131 23.8463 26.685C23.3213
                            26.8913 22.5262 27.135 21.0619 27.2025C19.4812 27.2738 19.0069 27.2906 15.0019
                            27.2906C10.9969 27.2906 10.5206 27.2738 8.94 27.2025C7.4775 27.135 6.68437 26.8913
                            6.15562 26.685C5.50469 26.4436 4.9155 26.0606 4.43062 25.5637C3.93239 25.0793 3.54812
                            24.49 3.30562 23.8387C3.10125 23.3119 2.85563 22.5169 2.79 21.0544C2.71875 19.4738
                            2.70375 18.9994 2.70375 14.9925C2.70375 10.9856 2.71875 10.515 2.79 8.93437C2.8575
                            7.47187 3.10125 6.67688 3.3075 6.14813C3.57938 5.44875 3.90562 4.94812 4.43062
                            4.42312C4.95563 3.89812 5.45437 3.57375 6.15562 3.30188C6.68437 3.09563 7.4775 2.85188
                            8.94 2.78437C10.3238 2.72062 10.86 2.70188 13.6556 2.7V2.70375ZM23.0081 5.19375C22.7717
                            5.19375 22.5377 5.24031 22.3193 5.33077C22.1009 5.42123 21.9025 5.55381 21.7353
                            5.72096C21.5682 5.8881 21.4356 6.08653 21.3451 6.30492C21.2547 6.52331 21.2081 6.75737
                            21.2081 6.99375C21.2081 7.23013 21.2547 7.46419 21.3451 7.68258C21.4356 7.90097 21.5682
                            8.0994 21.7353 8.26654C21.9025 8.43369 22.1009 8.56627 22.3193 8.65673C22.5377 8.74719
                            22.7717 8.79375 23.0081 8.79375C23.4855 8.79375 23.9434 8.60411 24.2809 8.26654C24.6185
                            7.92898 24.8081 7.47114 24.8081 6.99375C24.8081 6.51636 24.6185 6.05852 24.2809
                            5.72096C23.9434 5.38339 23.4855 5.19375 23.0081 5.19375ZM15.0019 7.2975C13.9801 7.28156
                            12.9654 7.46904 12.0168 7.84901C11.0682 8.22899 10.2047 8.79388 9.47653 9.51079C8.74835
                            10.2277 8.17006 11.0823 7.77533 12.0249C7.3806 12.9674 7.17731 13.9791 7.17731
                            15.0009C7.17731 16.0228 7.3806 17.0345 7.77533 17.977C8.17006 18.9196 8.74835 19.7742
                            9.47653 20.4911C10.2047 21.208 11.0682 21.7729 12.0168 22.1529C12.9654 22.5328 13.9801
                            22.7203 15.0019 22.7044C17.0241 22.6728 18.9529 21.8473 20.3718 20.4061C21.7908 18.9649
                            22.5861 17.0234 22.5861 15.0009C22.5861 12.9784 21.7908 11.037 20.3718 9.59578C18.9529
                            8.15454 17.0241 7.32905 15.0019 7.2975ZM15.0019 9.99938C15.6586 9.99938 16.3088 10.1287
                            16.9155 10.38C17.5222 10.6313 18.0735 10.9997 18.5379 11.464C19.0022 11.9284 19.3705
                            12.4796 19.6219 13.0863C19.8732 13.693 20.0025 14.3433 20.0025 15C20.0025 15.6567 19.8732
                            16.307 19.6219 16.9137C19.3705 17.5204 19.0022 18.0716 18.5379 18.536C18.0735 19.0003
                            17.5222 19.3687 16.9155 19.62C16.3088 19.8713 15.6586 20.0006 15.0019 20.0006C13.6756
                            20.0006 12.4037 19.4738 11.4659 18.536C10.5281 17.5982 10.0013 16.3262 10.0013 15C10.0013
                            13.6738 10.5281 12.4018 11.4659 11.464C12.4037 10.5262 13.6756 9.99938 15.0019 9.99938Z"
                              fill="#ACACAC" />
                          </g>
                          <defs>
                            <clipPath id="clip0_28_649">
                              <rect width="30" height="30" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                    </li>
                    <li>
                      <button
                        @click="shareSocial('whatsapp')"
                        class="btn btn-default social_share"
                        title="WhatsApp">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none">
                          <g clip-path="url(#clip0_28_651)">
                            <path
                              d="M25.5019 4.36135C24.1268 2.97291 22.4889 1.87219 20.6839 1.1234C18.8789 0.37462
                            16.9429 -0.00723904 14.9887 0.000103922C6.80062 0.000103922 0.1275 6.67135 0.12
                            14.8614C0.12 17.4845 0.80625 20.0364 2.10188 22.2957L0 30.0001L7.8825 27.9339C10.0622
                            29.123 12.5058 29.7452 14.9887 29.7432H14.9963C23.1863 29.7432 29.8575 23.072 29.865
                            14.8745C29.8667 12.9208 29.4819 10.9862 28.7327 9.18187C27.9836 7.37757 26.8868 5.73929
                            25.5019 4.36135ZM14.9887 27.227C12.7747 27.2252 10.6017 26.6295 8.69625 25.502L8.24625
                            25.232L3.57 26.4582L4.81875 21.8964L4.52625 21.4257C3.28839 19.4576 2.63371 17.1789
                            2.63812 14.8539C2.63812 8.0551 8.1825 2.50885 14.9963 2.50885C16.6195 2.50594 18.2273
                            2.82437 19.7269 3.44578C21.2265 4.06718 22.5883 4.97928 23.7337 6.12948C24.8829 7.27538
                            25.794 8.63737 26.4144 10.137C27.0349 11.6366 27.3524 13.2441 27.3488 14.867C27.3413
                            21.6901 21.7969 27.227 14.9887 27.227ZM21.7669 17.9757C21.3975 17.7901 19.5731 16.892
                            19.23 16.7645C18.8888 16.6426 18.6394 16.5789 18.3956 16.9501C18.1462 17.3195 17.4338
                            18.1614 17.22 18.4032C17.0063 18.6526 16.785 18.6807 16.4137 18.497C16.0444 18.3095
                            14.8463 17.9195 13.4288 16.6501C12.3225 15.6657 11.5819 14.447 11.3606 14.0776C11.1469
                            13.7064 11.34 13.5076 11.5256 13.322C11.6887 13.157 11.895 12.887 12.0806 12.6732C12.2681
                            12.4595 12.33 12.302 12.4519 12.0545C12.5737 11.8032 12.5156 11.5895 12.4237
                            11.4039C12.33 11.2182 11.5894 9.38635 11.2762 8.6476C10.9762 7.91823 10.6706 8.01948
                            10.4419 8.0101C10.2281 7.99698 9.97875 7.99698 9.72937 7.99698C9.54108 8.00177 9.35579
                            8.04538 9.18512 8.12507C9.01445 8.20476 8.86207 8.31882 8.7375 8.4601C8.39625 8.83135
                            7.44187 9.72948 7.44187 11.5614C7.44187 13.3932 8.77312 15.1539 8.96062 15.4032C9.14437
                            15.6526 11.5744 19.4007 15.3037 21.0132C16.185 21.3976 16.8787 21.6245 17.4206
                            21.797C18.3113 22.082 19.1156 22.0389 19.7569 21.947C20.4694 21.8382 21.9525 21.047
                            22.2656 20.1789C22.5731 19.3089 22.5731 18.5664 22.4794 18.4107C22.3875 18.2532 22.1381
                            18.1614 21.7669 17.9757Z"
                              fill="#ACACAC" />
                          </g>
                          <defs>
                            <clipPath id="clip0_28_651">
                              <rect width="30" height="30" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="container-images">
              <div class="gallery-wrapper">
                <img :src="model.dynamicGalleries?.[2]?.fullUrl" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div
          class="container-accordion"
          :class="{
            'navy-color': model.reference === 'Navy',
            'mint-color': model.reference === 'Mint',
            'pink-color': model.reference === 'Pink',
            'snow-color': model.reference === 'Snow',
          }">
          <h2
            :class="{
              'navy-color': model.reference === 'Navy',
              'mint-color': model.reference === 'Mint',
              'pink-color': model.reference === 'Pink',
              'snow-color': model.reference === 'Snow',
            }">
            Especificações
          </h2>
          <Accordion
            v-if="ReferenceModel.dynamicTables"
            :tables="ReferenceModel.dynamicTables"
            :model="model"
            :documents="model.documents" />
        </div>

        <div class="container-info-product">
          <div
            class="container-gallery-image"
            :class="{
              'navy-color': model.reference === 'Navy',
              'mint-color': model.reference === 'Mint',
              'pink-color': model.reference === 'Pink',
              'snow-color': model.reference === 'Snow',
            }">
            <gallery-image :gallery="model.dynamicGalleries.slice(1)" />
          </div>
          <div
            class="container-banner"
            v-if="model.dynamicGalleries && model.dynamicGalleries.length > 0">
            <div
              class="banner"
              :class="{
                'navy-color': model.reference === 'Navy',
                'mint-color': model.reference === 'Mint',
                'pink-color': model.reference === 'Pink',
                'snow-color': model.reference === 'Snow',
              }">
              <img
                :src="model.dynamicGalleries[3].fullUrl"
                :alt="model.dynamicGalleries[3].title" />
            </div>
          </div>
          <div
            class="header"
            :class="{
              'navy-color': model.reference === 'Navy',
              'mint-color': model.reference === 'Mint',
              'pink-color': model.reference === 'Pink',
              'snow-color': model.reference === 'Snow',
            }">
            <p>Detalhes que fazem a diferença</p>
          </div>
          <div class="content-images">
            <slide-show
              :icons="model.iconography"
              :major="ReferenceModel.majorCategory"
              :model="model" />
          </div>

          <div class="container-other-gamas">
            <h2
              :class="{
                'navy-color': model.reference === 'Navy',
                'mint-color': model.reference === 'Mint',
                'pink-color': model.reference === 'Pink',
                'snow-color': model.reference === 'Snow',
              }">
              Outras gamas disponíveis
            </h2>
            <div class="container-related-product" style="width: 100%">
              <slider-gamas-urbano
                :related="model.relatedProduct"
                :model="model" />
            </div>
          </div>
        </div>
      </div>
      <ModalContact
        v-model="showModal"
        :model="model"
        :productName="ReferenceModel"
        :productVariant="model" />
    </div>
  </div>
</template>

<style scoped>
.description :deep(blockquote) {
  font-weight: bold;
}

.description.mint-color :deep(blockquote) {
  color: #46a9aa;
}
.description.navy-color :deep(blockquote) {
  color: #274775;
}
.description.pink-color :deep(blockquote) {
  color: #e690a2;
}
.description.snow-color :deep(blockquote) {
  color: #dbbf92;
}
.content-area-selection {
  margin-bottom: 20px;
  padding-bottom: 10px;
}

.content-area-selection h5 {
  font-size: 12px;
  color: #333;
  text-transform: uppercase;
}

.area-buttons {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.area-buttons button {
  padding: 8px 15px;
  background-color: #f5f5f5;
  border-radius: 5px;
  border: none;
  color: #999;
  font-family:
    Bai Jamjuree,
    serif;
  text-transform: uppercase;
  font-size: 12px;
  cursor: pointer;
}

.area-buttons button.active {
  border: none;
  color: #fff;
  background-color: #333333;
}

.area-buttons button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.content-colors .card.active-color {
  border: 3px solid #007bff;
}

.container-produto {
  padding-bottom: 60px;
}
</style>
